import React, { FC } from 'react';

type HiddenProps = {
  hidden: boolean;
  children?: React.ReactNode;
};

export const Hidden: FC<HiddenProps> = ({ children, hidden }) => {
  return <>{hidden ? null : children}</>;
};
